import { render, staticRenderFns } from "./BlankModel.vue?vue&type=template&id=1e383b50&"
import script from "./BlankModel.vue?vue&type=script&lang=js&"
export * from "./BlankModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports